module.exports = __webpack_public_path__ + "static/androidBannerCTOGrammBig-39375a1a079ee84b67e08e87d04b24e1.png";